import React from "react"
import styled from "styled-components"

import FooterLogo from "../../images/footer-logo.svg"

const Wrapper = styled.div`
  margin-top: 4rem;
  padding-bottom: 2rem;

  a:hover {
    text-decoration: underline;
  }
`

const LogoWrapper = styled.div`
  margin-bottom: 0.5rem;

  path {
    transition: all 0.2s ease-in-out;
  }

  .light-bg {
    /* fill: ${props => props.theme.color.lightBg}; */
    fill: #fff;
  }

  .logo-bg {
    fill: ${props => props.theme.color.primaryBackground};
  }
`

export default function Colophon(props) {
  return (
    <Wrapper>
      <LogoWrapper>
        <FooterLogo />
      </LogoWrapper>
      <p>
        &copy; {new Date().getFullYear()} &bull; f'real foods LLC &bull;{" "}
        <a href="https://www.richs.com/privacy/">Privacy Policy</a> &bull;{" "}
        <a href="https://www.richs.com/terms-and-conditions-of-use/">
          Terms &amp; Conditions
        </a>{" "}
        <br />
        <a href="https://privacyportal.onetrust.com/webform/33037e9f-6516-4654-8f7c-8e3dc91db6b3/efa0737f-ff27-4379-b205-d6eb25443c91">
          Exercising Your Privacy Rights
        </a>{" "}
        &bull;{" "}
        <a href="https://privacyportal.onetrust.com/webform/33037e9f-6516-4654-8f7c-8e3dc91db6b3/efa0737f-ff27-4379-b205-d6eb25443c91">
          Do Not Sell or Share My Personal Information
        </a>
      </p>
    </Wrapper>
  )
}
